import {PlatformPreviewItem} from '@/components/Ui-components/CommonSections/PlatformPreviews';
import {cdnImage} from '@/util/cdnImage';
const processChevronDown = cdnImage('web3/Web3-Process-ChevronDown.svg');
const processChevronRight = cdnImage('web3/Web3-Process-ChevronRight.svg');
const processCheckIcon = cdnImage('web3/Web3-Process-CheckIcon.svg');
const awsBedrock = cdnImage('ai-copliot-development-new/AWS-Bedrock-partner-logo.webp');
const microsoftCopilot = cdnImage('ai-copliot-development-new/Microsoft-Copilot-Studio-partner-logo.webp');
const githubCopilot = cdnImage('ai-copliot-development-new/GitHub-Copilot-partner-logo.webp');
const azureOpenAI = cdnImage('ai-copliot-development-new/Azure-OpenAI-Service-partner-logo.webp');
const claudeAnthropic = cdnImage('ai-copliot-development-new/Anthropic-Claude-partner-logo.webp');
const autogen = cdnImage('ai-copliot-development-new/Autogen-partner-logo.webp');
export const aiCopilotBottom = [
    {
        src: microsoftCopilot,
        alt: 'Microsoft Copilot Studio'
    },
    {
        src: githubCopilot,
        alt: 'Github Copilot'
    },
    {
        src: azureOpenAI,
        alt: 'Azure OpenAI Service'
    },
    {
        src: awsBedrock,
        alt: 'AWS Bedrock'
    },
    {
        src: claudeAnthropic,
        alt: 'Anthropic Claude'
    },

    {
        src: autogen,
        alt: 'Autogen'
    }
];

export const copilotDecodingContent = [
    'The leading AI copilots — GPT-4, Claude, Gemini, and Microsoft Copilot — represent the most capable intelligent automation available today. The organizations extracting the most value from these models are not building new AI — they are deploying it with precision across their existing operations.',
    'Debut Infotech delivers comprehensive AI copilot integration services — embedding foundation models into the enterprise tools, workflows, and applications your teams already use. Whether you require AI Copilot integration with existing tools such as Salesforce, SAP, or Microsoft 365, or a full Azure AI Foundry Copilot Studio integration within your Microsoft environment, we architect and deploy solutions built specifically around your business context.',
    'We connect, configure, and orchestrate AI copilots across your CRMs, ERPs, support platforms, and custom applications — ensuring that every deployment understands your data, processes, and operational requirements.',
    'The outcome is measurable: reduced manual effort, faster decision-making, and enterprise-grade AI copilot capability embedded precisely where it creates the most value.'
];

const strategic = cdnImage('ai-copliot/Strategic-Business-Assessment.webp');
const tailored = cdnImage('ai-copliot/AI-Copilot-Development.webp');
const smooth = cdnImage('ai-copliot/Smooth-AI-Copilot-Integration.webp');
const prototype = cdnImage('ai-copliot/AI-Prototype-Development.webp');
const optimization = cdnImage('ai-copliot/Continuous-Optimization-Support.webp');
const data = cdnImage('ai-copliot/Data-Preparation-Engineering.webp');
export const copilotDevelopmentService = [
    {
        icon: strategic,
        heading: 'Strategic Business Assessment',
        redirect: '',
        body: "We start with an in-depth evaluation of your organization's challenges and goals. Through collaborative consultations, we identify how AI Copilot development can address pain points, improve efficiency, and optimize workflows, ensuring measurable results for your enterprise."
    },
    {
        icon: tailored,
        heading: 'Tailored AI Copilot Development',
        redirect: '',
        body: 'Our team specializes in custom AI Copilot development tailored to your business needs. Using advanced AI models, NLP, and machine learning development techniques, we create intelligent solutions that seamlessly integrate with existing processes for enhanced operational outcomes.'
    },
    {
        icon: smooth,
        heading: 'Smooth AI Copilot Integration',
        redirect: '',
        body: 'As an AI Copilot integration company, we ensure your systems transition smoothly to AI-powered workflows. By prioritizing data security and compliance, we create robust solutions that fit within your infrastructure, reducing disruptions and improving scalability.'
    },
    {
        icon: prototype,
        heading: 'AI Prototype Development',
        redirect: '',
        body: 'We offer AI Copilot app development prototypes, allowing enterprises to evaluate potential performance within specific workflows. This approach helps validate effectiveness, mitigate risks, and guide informed decisions before moving toward large-scale implementation.'
    },
    {
        icon: optimization,
        heading: 'Continuous Optimization and Support',
        redirect: '',
        body: 'Our AI Copilot development services include continuous maintenance and optimization. We update solutions in line with the latest advancements in AI and machine learning, ensuring sustained performance and enabling businesses to stay ahead in innovation.'
    },
    {
        icon: data,
        heading: 'Data Preparation and Engineering',
        redirect: '',
        body: 'High-quality data is the backbone of effective AI Copilot solutions. Our data preparation and engineering services ensure your data is cleaned, structured, and optimized to maximize the precision of AI Copilot app development and deliver actionable results.'
    }
];

const aware = cdnImage('ai-copliot/Context-Aware-Assistance.webp');
const multiModal = cdnImage('ai-copliot/Multi-Modal-Interaction.webp');
const intelligent = cdnImage('ai-copliot/Intelligent-Task-Support.webp');
const personal = cdnImage('ai-copliot/Personalized-User-Experience.webp');
const transparent = cdnImage('ai-copliot/Transparent-AI-Explanations.webp');
const humanAi = cdnImage('ai-copliot/Human-AI-Collaboration.webp');
const support = cdnImage('ai-copliot/Omnichannel-Support-Integration.webp');
const analytics = cdnImage('ai-copliot/Advanced-Analytics-Insights.webp');
const rapid = cdnImage('ai-copliot/Rapid-Prototyping-Validation.webp');
export const aiCopilotSolutionFeature = [
    {
        icon: aware,
        alt: 'Context-Aware Assistance',
        heading: 'Context-Aware Assistance',
        redirect: '',
        body: 'Our AI Copilots adapt to specific tasks, analyzing environmental factors and user behaviors to provide relevant, actionable support. This ensures smarter decision-making and precise execution across diverse workflows, enhancing productivity and user engagement.'
    },
    {
        icon: multiModal,
        alt: 'Multi-Modal Interaction',
        heading: 'Multi-Modal Interaction',
        redirect: '',
        body: 'Designed for seamless communication, our AI Copilot solutions support voice, text, and visual inputs, ensuring flexible and user-friendly interactions. This adaptability caters to various business requirements, streamlining operations through advanced machine learning development techniques.'
    },
    {
        icon: intelligent,
        alt: 'Intelligent Task Support',
        heading: 'Intelligent Task Support',
        redirect: '',
        body: 'Our solutions assist with tasks like writing, coding, research, and data analysis, reducing manual effort. By leveraging context-aware algorithms, businesses can enhance productivity and achieve more accurate outcomes through custom AI agent development.'
    },
    {
        icon: personal,
        alt: 'Personalized User Experience',
        heading: 'Personalized User Experience',
        redirect: '',
        body: 'By learning from user interactions, our AI Copilots provide tailored recommendations and adaptive behaviors. This customized approach enhances user satisfaction, offering businesses a unique edge with specialized solutions.'
    },
    {
        icon: transparent,
        alt: 'Transparent AI Explanations',
        heading: 'Transparent AI Explanations',
        redirect: '',
        body: 'We integrate trending AI techniques, enabling Copilots to justify their decisions. This builds trust, ensures regulatory compliance, and allows users to better understand suggestions, critical for decision-driven businesses.'
    },
    {
        icon: humanAi,
        alt: 'Enhanced Human-AI Collaboration',
        heading: 'Enhanced Human-AI Collaboration',
        redirect: '',
        body: 'Acting as supportive partners, our AI Copilots complement human efforts, improving team performance. This collaborative approach ensures efficiency in handling complex workflows while fostering better operational outcomes across industries.'
    },
    {
        icon: support,
        alt: 'Omnichannel Support Integration',
        heading: 'Omnichannel Support Integration',
        redirect: '',
        body: 'Our AI Copilots work seamlessly across platforms like Slack, mobile apps, and web portals. This ensures consistent communication and operational efficiency, meeting the demands of businesses needing scalable AI agent development.'
    },
    {
        icon: analytics,
        alt: 'Advanced Analytics and Insights',
        heading: 'Advanced Analytics and Insights',
        redirect: '',
        body: 'Powered by real-time analytics, our AI Copilots deliver actionable insights that help businesses optimize processes and improve decision-making. This capability supports data-driven strategies and accelerates outcomes in competitive industries.'
    },
    {
        icon: rapid,
        alt: 'Rapid Prototyping and Validation',
        heading: 'Rapid Prototyping and Validation',
        redirect: '',
        body: 'With Proof of Concept (PoC) and Minimum Viable Product (MVP) capabilities, our AI Copilot solutions ensure quick iterations. This approach validates potential and aligns implementations with business needs, saving time and resources effectively.'
    }
];

const tensorFlow = cdnImage('hire-remote-developer/TensorFlow.webp');
const pyTorch = cdnImage('hire-remote-developer/PyTorch.webp');
const keras = cdnImage('generative-ai-integration/Keras.webp');
const huggingFaceInferenceAPI = cdnImage('generative-ai-integration/Hugging-Face-Inference-API.webp');
const bert = cdnImage('generative-ai-integration/BERT.webp');
const spark = cdnImage('generative-ai-integration/Apache-Spark.webp');
const pandas = cdnImage('generative-ai-integration/Pandas.webp');
const numPY = cdnImage('hire-remote-developer/NumPy.webp');
const tableAu = cdnImage('hire-remote-developer/Tableau.webp');
const aws = cdnImage('hire-remote-developer/aws.webp');
const azure = cdnImage('hire-remote-developer/Microsoft-Azure.webp');
const googleCloud = cdnImage('hire-remote-developer/Google-Cloud-Platform.webp');
const docker = cdnImage('hire-remote-developer/docker.webp');
const kubernet = cdnImage('hire-remote-developer/Kubernetes.webp');
const restfulAPIs = cdnImage('ai-copliot/REST.webp');
const graphql = cdnImage('ai-copliot/GraphQL.webp');
const postman = cdnImage('hire-remote-developer/Postman.webp');
const openAIDallE = cdnImage('generative-ai-integration/DALL-E.webp');
const ssl = cdnImage('crypto-exchange/SSL-TLS-Encryption.webp');
const scikit = cdnImage('hire-remote-developer/Scikit-learn.webp');
const openAIGPT = cdnImage('generative-ai-integration/GPT-4.webp');
const spacy = cdnImage('ai-copliot/spaCy.webp');
const nltk = cdnImage('ai-copliot/NLTK.webp');
const stableDiffusion = cdnImage('generative-ai-integration/Stable-Diffusion.webp');
const WebRTC = cdnImage('ai-copliot/WebRTC.webp');
const twillo = cdnImage('ai-copliot/Twilio.webp');
const dialog = cdnImage('ai-copliot/Dialogflow.webp');
const polly = cdnImage('ai-copliot/Amazon-Polly.webp');
const gprc = cdnImage('ai-copliot/gRPC.webp');
const gptModal = cdnImage('ai-copliot/GPT-Models.webp');
const auth = cdnImage('ai-copliot/OAuth-2.webp');
const iam = cdnImage('ai-copliot/IAM.webp');
const openCV = cdnImage('ai-copliot/OpenCV.webp');
const yolo = cdnImage('ai-copliot/YOLO.webp');
const tensorFlow1 = cdnImage('ai-copliot/TensorFlow-Vision.webp');
export const copilotDevelopmentTechData = [
    {
        heading: 'ML & Deep Learning Frameworks',
        values: [
            {icon: tensorFlow, label: 'TensorFlow'},
            {icon: pyTorch, label: 'PyTorch'},
            {icon: scikit, label: 'Scikit-learn'},
            {icon: keras, label: 'Keras'}
        ]
    },
    {
        heading: 'Natural Language Processing (NLP) Tools',
        values: [
            {icon: spacy, label: 'spaCy'},
            {icon: nltk, label: 'NLTK'},
            {icon: huggingFaceInferenceAPI, label: 'Hugging Face Transformers'},
            {icon: bert, label: 'BERT'},
            {icon: openAIGPT, label: 'GPT-4'}
        ]
    },
    {
        heading: 'Data Processing & Analytics Platforms',
        values: [
            {icon: spark, label: 'Apache Spark'},
            {icon: pandas, label: 'Pandas'},
            {icon: numPY, label: 'NumPy'},
            {icon: tableAu, label: 'Tableau'}
        ]
    },
    {
        heading: 'Cloud & Edge Computing Infrastructure',
        values: [
            {icon: aws, label: 'AWS'},
            {icon: azure, label: 'Microsoft Azure'},
            {icon: googleCloud, label: 'Google Cloud'},
            {icon: kubernet, label: 'Kubernetes'},
            {icon: docker, label: 'Docker'}
        ]
    },
    {
        heading: 'System Integration & API Development',
        values: [
            {icon: restfulAPIs, label: 'REST'},
            {icon: graphql, label: 'GraphQL'},
            {icon: gprc, label: 'gRPC'},
            {icon: postman, label: 'Postman'}
        ]
    },
    {
        heading: 'Multi-Modal Interaction Technologies',
        values: [
            {icon: WebRTC, label: 'WebRTC'},
            {icon: twillo, label: 'Twilio'},
            {icon: dialog, label: 'Dialogflow'},
            {icon: polly, label: 'Amazon Polly'}
        ]
    },
    {
        heading: 'Generative AI & Content Creation Models',
        values: [
            {icon: openAIDallE, label: 'DALL-E'},
            {icon: stableDiffusion, label: 'Stable Diffusion'},
            {icon: gptModal, label: 'GPT Models'}
        ]
    },
    {
        heading: 'Security & Compliance Solutions',
        values: [
            {icon: auth, label: 'OAuth 2.0'},
            {icon: ssl, label: 'SSL/TLS'},
            {icon: iam, label: 'IAM'}
        ]
    },

    {
        heading: 'Computer Vision Tools',
        values: [
            {icon: openCV, label: 'OpenCV'},
            {icon: yolo, label: 'YOLO'},
            {icon: tensorFlow1, label: 'TensorFlow Vision'}
        ]
    }
];

const boost = cdnImage('ai-copliot/Boost-Productivity.webp');
const contextual = cdnImage('ai-copliot/Contextual-Insights.webp');
const realTime = cdnImage('ai-copliot/Real-Time-Support.webp');
const omnichannel = cdnImage('ai-copliot/Omnichannel-Integration.webp');
const foster = cdnImage('ai-copliot/Foster-Creativity.webp');
const accuracy = cdnImage('ai-copliot/Data-Accuracy.webp');
const collaboration = cdnImage('ai-copliot/Enhance-Collaboration.webp');
const scalable = cdnImage('ai-copliot/Scalable-Solutions.webp');
const drive = cdnImage('ai-copliot/Drive-Informed-Decisions.webp');
export const centricCopilotCompany = [
    {
        icon: boost,
        heading: 'Boost Productivity',
        redirectLink: '',
        body: 'Our AI Copilots optimize workflows by anticipating user needs and providing actionable suggestions. By integrating with enterprise systems like IT, HR, and finance, they help save time and improve operational efficiency across departments.'
    },
    {
        icon: contextual,
        heading: 'Contextual Insights',
        redirectLink: '',
        body: 'Using advanced <a target="_blank" href="/blog/a-comprehensive-guide-to-understanding-and-using-ai-models">AI models</a> and machine learning, our solutions deliver context-aware information drawn from internal databases and trusted external sources, ensuring accurate and relevant suggestions for users.'
    },
    {
        icon: realTime,
        heading: 'Real-Time Support',
        redirectLink: '',
        body: "Our <a href='/ai-chatbot-development-company' target='_blank'>AI-powered Copilots</a> offer immediate assistance to employees and customers. They help resolve tasks, answer queries, and address challenges in real time, improving overall efficiency and productivity."
    },
    {
        icon: omnichannel,
        heading: 'Omnichannel Integration',
        redirectLink: '',
        body: 'Our solutions support multiple platforms like Slack, Microsoft Teams, email, and mobile apps, providing consistent and seamless communication across the enterprise for both employees and customers.'
    },
    {
        icon: foster,
        heading: 'Foster Creativity',
        redirectLink: '',
        body: 'By automating repetitive tasks, our AI Copilots free teams to focus on innovation, helping them create detailed presentations, solve complex problems, and develop creative content with greater ease.'
    },
    {
        icon: accuracy,
        heading: 'Data Accuracy',
        redirectLink: '',
        body: 'Our AI Copilots deliver precise, up-to-date, and contextually relevant information, reducing errors and enhancing the quality and reliability of every interaction and decision-making process.'
    },
    {
        icon: collaboration,
        heading: 'Enhance Collaboration',
        redirectLink: '',
        body: 'AI Copilots act as a bridge for team communication and project management, streamlining collaboration and helping teams stay aligned on goals and progress.'
    },
    {
        icon: scalable,
        heading: 'Scalable Solutions',
        redirectLink: '',
        body: 'Built to adapt to changing business demands, our AI Copilots grow with your enterprise, offering consistent performance and enhanced features as your organization scales.'
    },
    {
        icon: drive,
        heading: 'Drive Informed Decisions',
        redirectLink: '',
        body: 'With actionable insights derived from advanced analytics, our AI Copilots support strategic decision-making, helping businesses confidently achieve their objectives.'
    }
];

export const neuronCopilotCheckPoint = [
    '60% Reduction in Average Response Time',
    '40% Increase in Customer Satisfaction',
    '50% Reduction in Workload for Human Agents',
    'Improved Operational Efficiency'
];

export const kedaptiveCopilotCHeckPoint = [
    '70% Increase in Student Engagement',
    '65% Improvement in Learning Outcomes',
    '50% Scalability Improvement for Growing Student Numbers',
    'Enhanced Academic Performance Metrics'
];

export const clerkieCheckPoint = [
    '85% Accuracy in Credit Scoring',
    '50% Reduction in Risk Analysis Time',
    '40% Improvement in Decision-Making Speed',
    'Enhanced Customer Trust Through Transparent Assessments'
];

export const lumenCheckPoint = [
    '75% Increase in Content Production Speed',
    '60% Improvement in Audience Engagement Rates',
    '40% Reduction in Content Creation Costs',
    'Consistent High-Quality Content Generation'
];

const machine = cdnImage('ai-copliot-development-new/RAG Pipeline Development.webp');
const nlp = cdnImage('ai-copliot-development-new/Natural Language Processing.webp');
const science = cdnImage('ai-copliot/Data-Science-Analytics.webp');
const cloudEdge = cdnImage('ai-copliot-development-new/Data Engineering  Pipeline Design.webp');
const system = cdnImage('ai-copliot-development-new/AI Model Integration and Orchestration.webp');
const frame = cdnImage('ai-copliot/Advanced-AI-Frameworks.webp');
const reinforcement = cdnImage('ai-copliot/Reinforcement-Learning.webp');
const modal = cdnImage('ai-copliot/Multi-Modal-Communication.webp');
const generative = cdnImage('ai-copliot-development-new/Generative AI.webp');
const predictive = cdnImage('ai-copliot-development-new/Predictive Analytics.webp');
const consulting = cdnImage('ai-copliot/AI-Consulting-Strategy.webp');
const scalibility = cdnImage('ai-copliot/Scalability-Adaptability.webp');
export const harnessTechnologyService = [
    {
        icon: machine,
        heading: 'Machine Learning and Deep Learning',
        redirect: '',
        body: 'Our <a target="_blank" href="/machine-learning-development-company">machine learning development</a> expertise enables us to build adaptive AI models using advanced algorithms. These models continuously learn from data to enhance precision and intelligence, ensuring smarter interactions and accurate outcomes.'
    },
    {
        icon: nlp,
        heading: 'Natural Language Processing (NLP)',
        redirect: '/blog/natural-language-processing-nlp',
        body: 'We craft AI Copilots with advanced NLP capabilities to understand, interpret, and generate human language seamlessly. This supports meaningful conversations and ensures communication across diverse AI use cases and industries.'
    },
    {
        icon: science,
        heading: 'Data Science and Analytics',
        redirect: '',
        body: 'Leveraging data science, we create AI Copilots that derive actionable insights from vast datasets. These insights power AI copilot development solutions that ensure informed decisions and a competitive edge for businesses.'
    },
    {
        icon: cloudEdge,
        heading: 'Cloud and Edge Computing',
        redirect: '',
        body: 'We design AI Copilots optimized for cloud and edge environments, ensuring scalability and efficiency. This makes us a trusted AI copilot development company for businesses aiming for uninterrupted and high-performance solutions.'
    },
    {
        icon: system,
        heading: 'System Integration and APIs',
        redirect: '',
        body: 'Our integration expertise enables seamless connections between AI Copilots and existing systems. As an AI copilot integration company, we enhance operational workflows while ensuring a unified user experience.'
    },
    {
        icon: frame,
        heading: 'Advanced AI Frameworks',
        redirect: '',
        body: 'Using cutting-edge <a target="_blank" href="/blog/ai-tools-and-frameworks">AI frameworks</a>, we accelerate the creation of robust, custom solutions. Our custom AI copilot development process ensures faster deployment without compromising on quality or innovation.'
    },
    {
        icon: reinforcement,
        heading: 'Reinforcement Learning',
        redirect: '',
        body: 'We implement reinforcement learning techniques to build AI Copilots that improve over time. These copilots, developed by experienced AI copilot developers, learn optimal strategies for tackling complex decision-making tasks.'
    },
    {
        icon: modal,
        heading: 'Multi-Modal Communication',
        redirect: '',
        body: 'Our AI Copilots enable interaction via text, voice, and gestures, ensuring accessibility for users. As an AI copilot for enterprises, we make communication seamless, enhancing adaptability and usability across business needs.'
    },
    {
        icon: generative,
        heading: 'Generative AI Models',
        redirect: '',
        body: 'We utilize <a target="_blank" href="/hire-generative-ai-developers">generative AI developers</a> to create copilots capable of assisting with creative tasks like content generation and ideation. These models provide significant value to workflows requiring innovation and problem-solving.'
    },
    {
        icon: predictive,
        heading: 'Predictive Analytics',
        redirect: '',
        body: "By integrating <a href='/blog/what-is-predictive-analytics' target='_blank'>predictive analytics</a>, we empower AI Copilots to forecast trends and mitigate risks. This capability aligns with our role as an <a target='_blank' href='/ai-agent-development-company'>AI agent development company</a>, helping businesses stay proactive and informed."
    },
    {
        icon: consulting,
        heading: 'AI Consulting and Strategy',
        redirect: '/ai-consulting-company',
        body: 'Our tailored AI copilot consulting services guide businesses in identifying opportunities for AI implementation. From strategy to deployment, we ensure enterprises derive maximum value from their AI investments.'
    },
    {
        icon: scalibility,
        heading: 'Scalability and Adaptability',
        redirect: '',
        body: 'We ensure our AI Copilots are scalable and flexible, addressing evolving challenges. As a leading AI copilot company, our solutions adapt seamlessly to changing requirements, ensuring long-term value for businesses.'
    }
];

export const aiCopilotChoiceBody = [
    "At <a href='/' target='_blank'>Debut Infotech</a>, we specialize in crafting tailored AI Copilot development solutions that enhance business efficiency and decision-making across industries. Our team excels in designing, integrating, and deploying intelligent copilots that adapt to unique business workflows, ensuring seamless automation, accuracy, and scalability.",
    'From utilizing advanced AI technologies to offering end-to-end support, we focus on delivering impactful AI Copilot solutions that drive measurable results. With a commitment to innovation and quality, we ensure our AI solutions align with your business goals, helping you stay competitive in a rapidly evolving landscape.'
];

export const aiCopilotChooseContent = [
    {
        heading: 'AI Expertise',
        subheading:
            'With over a decade of experience in AI and machine learning, we create cutting-edge solutions that deliver exceptional performance.'
    },
    {
        heading: 'Custom Solutions',
        subheading:
            'We design AI Copilots tailored to your specific business needs, ensuring seamless integration with your existing systems.'
    },
    {
        heading: 'Diverse Industry Knowledge',
        subheading:
            'Our extensive experience across 30+ industries, including finance, healthcare, education, and retail, allows us to effectively address diverse challenges.'
    },
    {
        heading: 'Advanced AI Models',
        subheading:
            'Our team utilizes state-of-the-art AI models, including NLP, computer vision, and generative AI, to build highly capable copilots.'
    },
    {
        heading: 'Scalable Architecture',
        subheading: 'We deliver solutions built for scalability, enabling your AI Copilots to grow and adapt to your business requirements.'
    },
    {
        heading: 'Data Security & Compliance',
        subheading:
            'We prioritize robust data security measures and ensure adherence to global regulatory standards to build trust and reliability.'
    }
];

const eCommerce = cdnImage('hire-ai-developers/Retail-eCommerce.webp');
const education = cdnImage('hire-ai-developers/Education.webp');
const banking = cdnImage('hire-ai-developers/Banking-Financial-Services.webp');
const healthcare = cdnImage('hire-ai-developers/Healthcare.webp');
const manufacturing = cdnImage('hire-ai-developers/Manufacturing.webp');
const realEstate = cdnImage('hire-ai-developers/Real-estate.webp');
const insurance = cdnImage('hire-ai-developers/Insurance.webp');
const gaming = cdnImage('DAO/Gaming.webp');
const supplyChain = cdnImage('DAO/Supply-Chain.webp');
export const copilotIndustry = [
    {
        icon: banking,
        alt: 'Finance',
        heading: 'Finance',
        redirect: '/fintech-software-development',
        body: 'AI Copilots optimize financial operations by automating tasks like risk assessment, reporting, and customer support. Our AI solutions ensure secure, efficient, and data-driven financial processes tailored to industry requirements.'
    },
    {
        icon: gaming,
        alt: 'Gaming',
        heading: 'Gaming',
        redirect: '',
        body: 'AI Copilots enhance gaming platforms by streamlining player engagement, automating updates, and offering real-time assistance. We create AI solutions that boost user experiences and operational efficiency.'
    },
    {
        icon: realEstate,
        alt: 'Real Estate',
        heading: 'Real Estate',
        redirect: '/real-estate-software-development',
        body: 'AI Copilots simplify property management with intelligent tools for data analysis, lead tracking, and client interactions. Our solutions improve decision-making and operational workflows for real estate businesses.'
    },
    {
        icon: healthcare,
        alt: 'Healthcare',
        heading: 'Healthcare',
        redirect: '/healthcare-app-development-company',
        body: 'From patient management to operational logistics, AI Copilots improve healthcare delivery by automating administrative tasks and ensuring accurate data handling. We build AI solutions tailored to the healthcare ecosystem.'
    },
    {
        icon: education,
        alt: 'Education',
        heading: 'Education',
        redirect: '/education-app-development-company',
        body: 'AI Copilots support educational institutions by automating administrative workflows, enabling personalized learning experiences, and enhancing student engagement. Our solutions foster collaboration and innovation in education.'
    },
    {
        icon: insurance,
        alt: 'Insurance',
        heading: 'Insurance',
        redirect: '',
        body: 'AI Copilots streamline claims processing, fraud detection, and policy management. Our solutions ensure faster response times and improved transparency for insurance providers.'
    },
    {
        icon: supplyChain,
        alt: 'Supply Chain',
        heading: 'Supply Chain',
        redirect: '',
        body: 'AI Copilot enables efficient supply chain management through real-time tracking, demand forecasting, and automated reporting. Our solutions bring transparency and accountability to global supply chain operations.'
    },
    {
        icon: eCommerce,
        alt: 'E-Commerce',
        heading: 'E-Commerce',
        redirect: '',
        body: 'AI Copilots improve e-commerce experiences by automating customer service, managing inventory, and analyzing consumer behavior. Our solutions help businesses deliver personalized and efficient services.'
    },
    {
        icon: manufacturing,
        alt: 'Manufacturing',
        heading: 'Manufacturing',
        redirect: '',
        body: 'AI Copilots support manufacturing operations with predictive maintenance, quality control, and resource planning. Our solutions ensure streamlined production processes and cost efficiency.'
    }
];

export const aiCopilotFAQ = [
    {
        question: 'What is Copilot development?',
        answer: {
            header: 'Copilot development involves creating intelligent AI-driven assistants that enhance productivity and decision-making by automating tasks, analyzing data, and offering contextual support. These copilots integrate advanced technologies like natural language processing, machine learning, and AI models to assist businesses in optimizing workflows, improving efficiency, and achieving scalable solutions tailored to specific operational needs.'
        }
    },
    {
        question: 'How do you ensure seamless integration with our systems?',
        answer: {
            header: 'We ensure seamless integration of AI Copilots by:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Conducting a detailed analysis of your existing systems and infrastructure.'
                        },
                        {
                            keyBody: 'Utilizing APIs and robust integration frameworks for compatibility across platforms.'
                        },
                        {
                            keyBody: 'Testing extensively for a smooth transition and minimal disruptions to workflows.'
                        },
                        {
                            keyBody: 'Providing ongoing support to resolve any integration challenges that arise.'
                        }
                    ]
                }
            ],
            footer: 'Our approach guarantees your AI Copilot fits into your workflows without impacting productivity, ensuring continuity and operational efficiency.'
        }
    },
    {
        question: 'What features can your AI Copilots offer?',
        answer: {
            header: 'Our AI Copilots come with a range of features, including:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Task automation for routine operations to improve overall efficiency.'
                        },
                        {
                            keyBody: 'Context-aware suggestions based on user inputs and business data.'
                        },
                        {
                            keyBody: 'Multi-modal interaction, including text, voice, and gesture-based inputs.'
                        },
                        {
                            keyBody: 'Real-time analytics and insights to support informed decision-making.'
                        },
                        {
                            keyBody: 'Secure and compliant data handling for dependable operations.'
                        }
                    ]
                }
            ],
            footer: 'These features are designed to enhance operational efficiency and user engagement, making them suitable for diverse enterprise needs.'
        }
    },
    {
        question: 'How do you address data security and compliance?',
        answer: {
            header: 'We prioritize robust data security by implementing advanced encryption protocols, access control measures, and secure data storage solutions. Our AI Copilot solutions comply with global regulatory standards such as GDPR, CCPA, and HIPAA, ensuring data privacy and trustworthiness. Regular audits and monitoring further ensure that your data remains protected at all times, minimizing risks and ensuring a secure operational environment.'
        }
    },
    {
        question: 'Are your copilot solutions scalable for future needs?',
        answer: {
            header: 'Yes, our AI Copilot solutions are designed with scalability in mind. We:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Use flexible architectures that grow with your business over time.'
                        },
                        {
                            keyBody: 'Support modular upgrades to enhance functionalities based on evolving needs.'
                        },
                        {
                            keyBody: 'Ensure adaptability to integrate new technologies, frameworks, and tools.'
                        }
                    ]
                }
            ],
            footer: 'This approach allows your AI Copilot to meet evolving business demands seamlessly and support innovation without disrupting current operations.'
        }
    },
    {
        question: 'Do you offer post-deployment support and maintenance?',
        answer: {
            header: 'Yes, we provide comprehensive post-deployment support to ensure your AI Copilot operates efficiently. Our services include:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Regular updates to incorporate advancements in AI technology and frameworks.'
                        },
                        {
                            keyBody: 'Performance monitoring to address potential issues proactively and avoid downtime.'
                        },
                        {
                            keyBody: '24/7 technical support to resolve challenges quickly and effectively.'
                        }
                    ]
                }
            ],
            footer: 'This ensures the long-term success and reliability of your solution, enabling uninterrupted operations and the highest level of performance.'
        }
    },
    {
        question: 'Can you provide a Proof of Concept before full deployment?',
        answer: {
            header: 'Yes, we offer Proof of Concept (PoC) development to validate the feasibility and potential of AI Copilot solutions. PoC allows you to:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Test specific use cases in your business environment with precision.'
                        },
                        {
                            keyBody: 'Identify areas for optimization and refinement before scaling the solution.'
                        },
                        {
                            keyBody: 'Minimize risks and make informed decisions about full deployment readiness.'
                        }
                    ]
                }
            ],
            footer: 'This stage ensures that your investment delivers results aligned with your expectations and business objectives.'
        }
    },
    {
        question: 'How do you measure the success of your AI Copilot solutions?',
        answer: {
            header: 'We measure the success of AI Copilot solutions by assessing:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Increased efficiency in workflows and faster task completion rates.'
                        },
                        {
                            keyBody: 'Improved decision-making through actionable insights and analytics support.'
                        },
                        {
                            keyBody: 'Enhanced user satisfaction and engagement with seamless interactions.'
                        },
                        {
                            keyBody: 'ROI through reduced operational costs and significant time savings.'
                        }
                    ]
                }
            ],
            footer: 'Regular performance tracking, client feedback, and iterative improvements help refine the solution and maintain alignment with business goals.'
        }
    },
    {
        question: 'What technologies and frameworks do you use?',
        answer: {
            header: 'We utilize state-of-the-art technologies such as:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Machine learning frameworks like TensorFlow and PyTorch for adaptive models.'
                        },
                        {
                            keyBody: 'Natural language processing tools like BERT, GPT models, and spaCy for seamless interactions.'
                        },
                        {
                            keyBody: 'Cloud platforms such as AWS, Google Cloud, and Azure for scalability.'
                        }
                    ]
                }
            ],
            footer: 'These technologies ensure robust, efficient, and scalable AI Copilot development tailored to your business requirements.'
        }
    },
    {
        question: 'What is the estimated AI Copilot Development cost and timeline?',
        answer: {
            header: 'The cost and timeline depend on factors like:',
            subpart: [
                {
                    keypoints: [
                        {
                            keyBody: 'Project complexity, including the number and scope of required features.'
                        },
                        {
                            keyBody: 'Data preparation, system integration, and customization efforts are involved.'
                        },
                        {
                            keyBody: 'Testing and validation processes to ensure accuracy and reliability.'
                        }
                    ]
                }
            ],
            footer: "Typically, development spans 8-16 weeks, with costs varying based on the project's scope. We provide detailed estimates after thoroughly understanding your unique requirements and operational goals."
        }
    }
];

const niken = cdnImage('ai-copliot/Niken-Patel.webp');
const gunsagar = cdnImage('ai-copliot/P-J-Gunsagar.webp');
const assad = cdnImage('ai-copliot/Guy-Assad.webp');
const cheng = cdnImage('ai-copliot/Michael-Cheng.webp');
export const copilotCaraculData = [
    {
        name: 'Niken Patel',
        discrption: `Debut Infotech played a pivotal role in enhancing our AI-driven customer support platform. Their expertise in NLP and seamless system integration transformed our vision into reality. The team demonstrated exceptional technical acumen, delivering a solution that significantly improved response times and operational efficiency. Working with them was a highly productive experience.`,
        profile: 'CEO & Co-Founder - Neuron7.ai',
        src: niken,
        isVideo: false,
        link: ''
    },
    {
        name: 'P.J. Gunsagar',
        discrption: `Collaborating with Debut Infotech was a game-changer for our adaptive learning platform. Their deep understanding of Generative AI enabled us to create personalized learning paths that have significantly enhanced student engagement. Their attention to detail and ability to scale solutions effectively make them a trusted partner for any AI-driven initiative.`,
        profile: 'Co-Founder - Kidaptive',
        src: gunsagar,
        isVideo: false,
        link: ''
    },
    {
        name: 'Guy Assad',
        discrption: `Debut Infotech's expertise in machine learning and risk assessment was instrumental in the success of our credit-scoring solution. Their ability to deliver tailored AI models while maintaining high accuracy and speed has been invaluable. They truly understand how to align technology with business needs, and we're thrilled with the results.`,
        profile: 'CEO - Clerkie',
        src: assad,
        isVideo: false,
        link: ''
    },
    {
        name: 'Michael Cheng',
        discrption: `Debut Infotech helped us elevate our content creation platform by implementing cutting-edge Generative AI solutions. Their innovative approach to automating high-quality content production allowed us to scale efficiently while improving audience engagement. The team's dedication and technical expertise were evident at every stage of the project, making the collaboration seamless and rewarding.`,
        profile: 'Co-Founder - Lumen5',
        src: cheng,
        isVideo: false,
        link: ''
    }
];

export const aiCopilotProcess = [
    {
        heading: 'Requirement Analysis and Planning',
        description:
            'We gather business insights, define project objectives, and create a detailed plan to address your specific challenges.'
    },
    {
        heading: 'Data Collection and Preparation',
        description: 'We collect, clean, and preprocess data to train AI models for accurate and efficient Copilot functionality.'
    },
    {
        heading: 'Model Development and Training',
        description: 'Our team develops customized AI models, leveraging advanced algorithms to align with your enterprise use cases.'
    },
    {
        heading: 'Integration with Existing Systems',
        description: 'We ensure seamless integration of the AI Copilot with existing workflows using APIs and advanced integration tools.'
    },
    {
        heading: 'Testing and Validation',
        description:
            'Rigorous testing is conducted to evaluate performance, accuracy, and reliability, ensuring a high-quality AI Copilot solution.'
    },
    {
        heading: 'Deployment and Monitoring',
        description: 'We deploy the AI Copilot, monitor its performance, and refine it to align with evolving business needs.'
    }
];

const BuildReal = cdnImage('ai-copliot-development-new/Built for Real Workflow Execution.webp');
const provenSystem = cdnImage('ai-copliot-development-new/Proven System Delivery  Experience.webp');
const eteIntegration = cdnImage('ai-copliot-development-new/End-to-End AI Copilot Integration Services.webp');
const seamlessIntegration = cdnImage('ai-copliot-development-new/Seamless Integration Across Business Systems.webp');

export const aiCopilotWhatSetsBestData = {
    heading: 'Why Choose Debut Infotech As Your AI Copilot Development & Integration Partner?',
    body: 'When evaluating AI copilot partners, the difference lies in execution—how well the system integrates with your workflows, how reliably it performs with your data, and how effectively it delivers value beyond initial deployment. As an AI copilot development company, we focus on building solutions that connect with your data, align with workflows, and deliver consistent outcomes across business environments.',
    features: [
        {
            icon: BuildReal,
            iconWidth: 24,
            iconHeight: 24,
            title: 'Built for Real Workflow Execution',
            description: 'Designed to operate inside real workflows, not as standalone tools, improving adoption across business teams.'
        },
        {
            icon: provenSystem,
            iconWidth: 24,
            iconHeight: 24,
            title: 'Proven System Delivery Experience',
            description: '15 years of engineering experience with 500+ solutions delivered across production environments.'
        },
        {
            icon: eteIntegration,
            iconWidth: 24,
            iconHeight: 24,
            title: 'End-to-End AI Copilot Integration Services',
            description: 'Full-stack integration across data, models, and applications, reducing gaps and accelerating deployment.'
        },
        {
            icon: seamlessIntegration,
            iconWidth: 24,
            iconHeight: 24,
            title: 'Seamless Integration Across Business Systems',
            description: 'Connected across CRM, ERP, and internal tools, enabling unified workflows across 5–10+ systems.'
        }
    ],
    deliverableEyebrow: 'EXPLORE DEBUT INFOTECH — STANDARD ENGAGEMENT DELIVERABLES',
    deliverableHeading: 'Full-Scope AI Copilot Development & Integration Deliverables',
    deliverables: [
        'Dedicated AI copilot architect',
        'Workflow analysis and use case mapping',
        'Copilot architecture design (models, data, orchestration)',
        'Integration with enterprise systems and data sources',
        'Knowledge pipeline and RAG setup',
        'Prompt and behavior configuration',
        'Real-world testing and validation',
        'Secure deployment with monitoring',
        'Access control and governance framework',
        'Data boundary and role-based safeguards',
        'Scalable system architecture',
        'High-concurrency performance optimization',
        'Data pipeline and infrastructure readiness'
    ]
};

export const aiCopilotIndustryGridData = [
    {
        src: nlp,
        heading: 'Natural Language Processing (NLP)',
        redirect: '/blog/natural-language-processing-nlp',
        body: 'Copilots rely on natural language processing to interpret user intent, understand context, and enable seamless interaction across business workflows.',
        body2: 'This includes intent recognition, multi-turn conversation handling, and domain-aware language understanding aligned to your business terminology.'
    },
    {
        src: generative,
        heading: 'Generative AI',
        redirect: '/generative-ai-development-company',
        body: 'Generative AI enables copilots to create content, summarise information, and generate structured outputs tailored to user roles and tasks.',
        body2: 'This includes drafting responses, transforming data into insights, and producing context-aware outputs for real-time business use cases.'
    },
    {
        src: machine,
        heading: 'Retrieval-Augmented Generation (RAG)',
        redirect: '',
        body: 'RAG allows copilots to deliver responses grounded in your internal data rather than relying solely on pre-trained knowledge.',
        body2: 'This includes retrieving information from documents and knowledge bases, improving response accuracy, and reducing hallucinations in critical workflows.'
    },
    {
        src: predictive,
        heading: 'Predictive Analytics',
        redirect: '/blog/what-is-predictive-analytics',
        body: 'Predictive analytics enables copilots to analyse historical data and provide forward-looking insights that support decision-making.',
        body2: 'This includes trend identification, anomaly detection, and generating recommendations based on patterns within business data.'
    },
    {
        src: cloudEdge,
        heading: 'Data Engineering & Pipeline Design',
        redirect: '/data-engineering-services',
        body: 'A strong data foundation ensures copilots operate with accurate, real-time, and well-structured information across systems.',
        body2: 'This includes data ingestion, transformation pipelines, and secure data access to maintain consistency and reliability in outputs.'
    },
    {
        src: system,
        heading: 'AI Model Integration & Orchestration',
        redirect: '',
        body: 'Modern copilots rarely rely on a single model. We design orchestration layers that combine multiple models and tools to handle different tasks efficiently.',
        body2: 'This includes routing queries, managing context, and ensuring each component contributes to accurate and consistent outputs.'
    }
];

const copilotPlatformOpenAI = cdnImage('ai-copliot-development-new/openai.webp');
const copilotPlatformClaude = cdnImage('ai-copliot-development-new/anthropic.webp');
const copilotPlatformGemini = cdnImage('ai-development-new/Google-Gemini.webp');
const copilotPlatformMsCopilot = cdnImage('Hire-dot-net-developer/CoPilot.webp');
const copilotPlatformLlama = cdnImage('ai/Llama-3.webp');
const copilotPlatformMistral = cdnImage('ai/Mistral.webp');
const copilotPlatformCohere = cdnImage('AI-Prompt-Engineering/Cohere-AI.webp');
const copilotPlatformAzure = cdnImage('generative-ai-consulting-company/Azure-OpenAI.webp');

export const aiCopilotPlatformModelsData = {
    heading: 'Enterprise AI Copilot Platforms We Deploy and Integrate for Scalable Adoption',
    subheading:
        'We work across a curated ecosystem of enterprise-grade <a href="/blog/a-comprehensive-guide-to-understanding-and-using-ai-models" target="_blank">AI models</a> and copilot platforms, enabling you to operationalise AI within existing systems and workflows. Our approach is platform-agnostic and commercially aligned—selecting the right foundation based on model capability, deployment flexibility, cost efficiency, compliance requirements, and your current technology stack or cloud agreements. This ensures every copilot integration is not only technically sound but also scalable, secure, and aligned with long-term enterprise objectives.',
    platforms: [
        {name: 'OpenAI GPT-4 / GPT-4o', logo: copilotPlatformOpenAI, logoWidth: 52, logoHeight: 52},
        {name: 'Anthropic Claude', logo: copilotPlatformClaude, logoWidth: 52, logoHeight: 52},
        {name: 'Google (Gemini)', logo: copilotPlatformGemini, logoWidth: 52, logoHeight: 52},
        {name: 'Microsoft Copilot', logo: copilotPlatformMsCopilot, logoWidth: 52, logoHeight: 52},
        {name: 'Meta (Llama)', logo: copilotPlatformLlama, logoWidth: 52, logoHeight: 52},
        {name: 'Mistral AI', logo: copilotPlatformMistral, logoWidth: 52, logoHeight: 52},
        {name: 'Cohere Command', logo: copilotPlatformCohere, logoWidth: 52, logoHeight: 52},
        {name: 'Azure OpenAI Service', logo: copilotPlatformAzure, logoWidth: 52, logoHeight: 52}
    ]
};

export const aiCopilotEngagementModelsData = {
    heading: 'Flexible Engagement Models Designed for Execution at Scale',
    subheading:
        'Every organisation operates with different priorities—speed, cost control, or long-term capability building. Our engagement models are structured to align with how you plan, build, and scale AI-powered systems, giving you the flexibility to choose what fits best.',
    models: [
        {
            title: 'Fixed Scope Engagement',
            description: 'Best suited for clearly defined copilot implementations with predetermined requirements and timelines.',
            bullets: [
                'End-to-end delivery with defined milestones and outcomes',
                'Predictable pricing aligned to the agreed scope',
                'Controlled execution with minimal operational overhead',
                'Ideal for MVPs and well-scoped deployments'
            ],
            tags: ['Clear timelines', 'Defined deliverables', 'Budget certainty', 'Minimal management effort'],
            ctaLabel: 'Start Fixed Scope Project'
        },
        {
            title: 'Time & Effort Model',
            description: 'Designed for evolving requirements where flexibility and iterative development are critical.',
            bullets: [
                'Scale development based on real-time priorities',
                'Continuous iteration as business needs evolve',
                'Transparent billing aligned to actual effort',
                'Best for ongoing enhancements and integrations'
            ],
            tags: ['Flexible scope adjustments', 'No rigid commitments', 'Agile development cycles', 'Pay for actual work delivered'],
            ctaLabel: 'Explore Flexible Engagement'
        },
        {
            title: 'Dedicated Copilot Team',
            description: 'Build a focused team that works as an extension of your internal engineering and product functions.',
            bullets: [
                'Full-time developers, AI engineers, and architects',
                'Aligned to your processes, tools, and delivery cadence',
                'Long-term ownership of development and optimisation',
                'Suitable for scaling complex AI initiatives'
            ],
            tags: ['Consistent delivery velocity', 'Deep domain alignment', 'Long-term scalability', 'Full control over priorities'],
            ctaLabel: 'Build Your Dedicated Team',
            featured: true,
            featuredLabel: 'Most Popular'
        },
        {
            title: 'Outcome-Based Delivery Model',
            description: 'Structured around measurable results rather than effort or hours, aligning execution with business impact.',
            bullets: [
                'Defined KPIs and performance benchmarks',
                'Milestone-based delivery tied to outcomes',
                'Reduced execution risk with shared accountability',
                'Ideal for transformation-led initiatives'
            ],
            tags: ['Pay for results, not time', 'Outcome-driven execution', 'Lower operational risk', 'Clear success metrics'],
            ctaLabel: 'Define Your Project Outcomes'
        }
    ]
};

export const aiCopilotDevProcessData = {
    heading: 'AI Copilot Development Process & Execution Framework',
    subheading:
        'We do not approach copilot implementation as a sequence of isolated tasks. It is a structured execution cycle that begins with workflow understanding, moves through system integration and model alignment, and continues into optimisation based on real usage patterns.\n\nHere is what that looks like in practice.',
    chevronDown: processChevronDown,
    chevronRight: processChevronRight,
    checkIcon: processCheckIcon,
    steps: [
        {
            title: 'We Start With Workflows, Not the Model',
            phase: 'PHASE 01',
            description:
                'Before selecting any model, platform, or framework, we analyse how work actually happens inside your organisation—where decisions are made, where delays occur, and where intelligence can create measurable impact.',
            checklistItems: [
                'Which workflows involve repetitive decision-making or manual effort?',
                'Where do teams rely on scattered data, documents, or institutional knowledge?',
                'Which systems (CRM, ERP, support tools) hold critical operational context?',
                'What level of accuracy, explainability, and control is required for each use case?',
                'We also define how the copilot will interact with users, what actions it can take, and where human validation must remain in place.'
            ],
            tags: ['Workflow Analysis', 'Use Case Discovery', 'Process Mapping', 'Decision Points', 'Operational Context']
        },
        {
            title: 'We Design the Copilot Architecture Around Your Systems',
            phase: 'PHASE 02',
            description:
                'Once workflows are clear, we define how the copilot fits into your existing technology environment—not as a separate tool, but as an embedded layer.',
            checklistItems: [
                'How will the copilot integrate with your current systems and APIs?',
                'What data sources will be accessed, and under what permissions?',
                'How will responses be generated, validated, and delivered?',
                'What latency, scale, and reliability benchmarks must be met?',
                'This stage ensures the architecture is built for real-world usage, not isolated demos.'
            ],
            tags: [
                'System Architecture',
                '<a href="/blog/how-to-integrate-generative-ai-api" target="_blank">API Integration</a>',
                'Data Flow Design',
                'Scalability Planning',
                'Reliability Engineering'
            ]
        },
        {
            title: 'We Build Context Through Data & Knowledge Integration',
            phase: 'PHASE 03',
            description:
                'A copilot is only as effective as the context it operates on. We connect it to your internal data, documents, and knowledge systems to ensure relevance and accuracy.',
            checklistItems: [
                'Which documents, databases, and knowledge bases should be indexed?',
                'How should structured and unstructured data be processed and retrieved?',
                'What access controls are required for different user roles?',
                'How do we ensure responses remain grounded in verified sources?',
                'This is where generic AI becomes business-aware.'
            ],
            tags: ['Knowledge Integration', 'Data Indexing', 'Vector Search', 'Access Control', 'Context Enrichment']
        },
        {
            title: 'We Configure Models, Prompts & Behavioural Logic',
            phase: 'PHASE 04',
            description:
                'The difference between a basic AI tool and a reliable copilot lies in how it is configured. We define how the system behaves under different scenarios.',
            checklistItems: [
                "What instructions guide the copilot's responses and tone?",
                'How should it handle ambiguity, edge cases, and incomplete inputs?',
                'What guardrails are required to prevent incorrect or unsafe outputs?',
                'When should the system escalate to human intervention?',
                'This layer ensures consistency, control, and trust in every interaction.'
            ],
            tags: ['Prompt Engineering', 'Model Configuration', 'Guardrail Design', 'Response Logic', 'Human-in-Loop']
        },
        {
            title: 'We Validate Through Testing, Simulation & Feedback Loops',
            phase: 'PHASE 05',
            description:
                'Before deployment, we rigorously test the copilot across real-world scenarios to ensure performance under operational conditions.',
            checklistItems: [
                'Does the copilot deliver accurate and contextually relevant responses?',
                'How does it perform under high usage and concurrent requests?',
                'Where do responses fail, and how can they be improved?',
                'What feedback mechanisms will capture ongoing improvements?',
                'Testing is treated as a continuous process, not a one-time step.'
            ],
            tags: ['Scenario Testing', 'Performance Validation', 'Load Testing', 'Feedback Loops', 'Accuracy Improvement']
        },
        {
            title: 'We Deploy, Monitor & Continuously Optimise',
            phase: 'PHASE 06',
            description:
                'Deployment is not the end state—it is the start of refinement. We monitor usage, analyse performance, and evolve the copilot based on real interaction patterns.',
            checklistItems: [
                'How are users interacting with the copilot across workflows?',
                'Where can response quality, speed, or accuracy be improved?',
                'What new use cases can be introduced based on adoption?',
                'How do we maintain alignment with evolving business needs?',
                'This ensures the copilot continues to improve and deliver measurable value over time.'
            ],
            tags: ['Production Deployment', 'Usage Monitoring', 'Performance Tuning', 'Continuous Optimization', 'Adoption Insights']
        }
    ]
};

// ─── COPILOT-SPECIFIC DATA (separate from ai-development-company) ────────────

// Growth section images
const copilotGrowth1 = cdnImage('ai-copliot-development-new/USD-Billion-Market-Forecast.webp');
const copilotGrowth2 = cdnImage('ai-copliot-development-new/30-per-cagr-enterprise-ai-adoption.webp');
const copilotGrowth3 = cdnImage('ai-copliot-development-new/40-per-of-Enterprise-Applications.webp');
const copilotGrowth4 = cdnImage('ai-copliot-development-new/90-per-of-Fortune-500.webp');

// CTA image
const copilotCTAImg = cdnImage('ai-copliot-development-new/AI-Copilots-access-cta.webp');
const copilotCTA2Img = cdnImage('ai-copliot-development-new/Build-an-AI-Copilot-Cta.webp');
const copilotCTA3Img = cdnImage('ai-copliot-development-new/Ready to Implement an AI Copilot-cta.webp');

// Expert images
const copilotExpertGurpreet = cdnImage('about-us-new/Gurpreet-singh-banner-image.webp');
const copilotExpertHarry = cdnImage('about-us-new/Harry-Dhillon.webp');

// KeyServices left image
export const copilotKeyImg = cdnImage('ai-copliot-development-new/AI-Copilot-Development-services.webp');

// Industry images (IndustriesWeServe)
const copilotIndHealthcare = cdnImage('ai-development-company/industries/healthcare.webp');
const copilotIndFintech = cdnImage('ai-development-company/industries/banking-finance.webp');
const copilotIndRetail = cdnImage('ai-development-company/industries/retail-ecommerce.webp');
const copilotIndManufacturing = cdnImage('ai-development-company/industries/manufacturing.webp');
const copilotIndLogistics = cdnImage('ai-development-company/industries/logistics-supply-chain.webp');
const copilotIndRealEstate = cdnImage('white-label-crypto-exchage/Real Estate.webp');
const copilotIndEducation = cdnImage('ai-development-company/industries/education.webp');
const copilotIndLegal = cdnImage('ai-development-company/industries/legal-services.webp');
const copilotIndInsurance = cdnImage('hire-ai-developers/Insurance.webp');
const copilotIndTravel = cdnImage('hire-ai-developers/Real-estate.webp');
const copilotIndMedia = cdnImage('ai-development-company/industries/media-entertainment.webp');
const copilotIndTelecom = cdnImage('ai-development-company/industries/telecommunications.webp');

// Tech stack images
const copilotTechOpenAI = cdnImage('hire-remote-developer/OpenAI-GPT.webp');
const copilotTechLangChain = cdnImage('generative-ai-consulting-company/LangChain.webp');
const copilotTechLlamaIndex = cdnImage('generative-ai-consulting-company/LlamaIndex.webp');
const copilotTechSemanticKernel = cdnImage('Ai-agent-development/Semantic-Kernel.webp');
const copilotTechHaystack = cdnImage('generative-ai-consulting-company/Haystack.webp');
const copilotTechPinecone = cdnImage('generative-ai-consulting-company/Pinecone.webp');
const copilotTechWeaviate = cdnImage('generative-ai-consulting-company/Weaviate.webp');
const copilotTechFAISS = cdnImage('generative-ai-consulting-company/FAISS.webp');
const copilotTechChroma = cdnImage('generative-ai-development/Chroma.webp');
const copilotTechElasticsearch = cdnImage('Hire-Prompt-engineer/elasticsearch.webp');
const copilotTechKafka = cdnImage('Java-development/apache-kafka.webp');
const copilotTechSnowflake = cdnImage('Hire-Machine-Learning-Engineers/Snowflake.webp');
const copilotTechDatabricks = cdnImage('Adaptive-AI-Development/Databricks.webp');
const copilotTechNodeJS = cdnImage('unique-school-images/nodejs.webp');
const copilotTechReact = cdnImage('talentQuest/React.webp');
const copilotTechAzure = cdnImage('hire-remote-developer/Microsoft-Azure.webp');
const copilotTechAWS = cdnImage('hire-remote-developer/aws.webp');
const copilotTechGCP = cdnImage('generative-ai-integration/Google-Cloud.webp');
const copilotTechDocker = cdnImage('Hire-SaaS-Developers/Docker.webp');
const copilotTechKubernetes = cdnImage('Hire-dot-net-developer/Kubernetes.webp');
const copilotTechAzureOpenAI = cdnImage('generative-ai-consulting-company/Azure-OpenAI.webp');
const copilotTechVertexAI = cdnImage('Hire-Machine-Learning-Engineers/google-vertex-ai.webp');
const copilotTechPython = cdnImage('hybrid-crypto-exchange/Python.webp');
const copilotTechAirflow = cdnImage('Adaptive-AI-Development/Apache-Airflow.webp');
const copilotTechGitHub = cdnImage('Hire-dot-net-developer/CoPilot.webp');
const copilotTechMsCopilot = cdnImage('Hire-dot-net-developer/CoPilot.webp');
const copilotTechMistral = cdnImage('ai/Mistral.webp');
const copilotTechCohere = cdnImage('AI-Prompt-Engineering/Cohere-AI.webp');
const copilotTechLlama = cdnImage('ai/Llama-3.webp');
const copilotTechGemini = cdnImage('ai-development-new/Google-Gemini.webp');
const copilotTechClaude = cdnImage('ai/Claude.webp');
const copilotTechDSPy = cdnImage('generative-ai-consulting-company/LangChain.webp');
const copilotTechDotNet = cdnImage('Hire-dot-net-developer/Dot-NET-Core.webp');
const copilotTechSpringBoot = cdnImage('hire-remote-developer/Spring-Boot.webp');
const copilotTechNextJs = cdnImage('Hire-team/next-js.webp');
const copilotTechTypeScript = cdnImage('hire-remote-developer/TypeScript.webp');
const copilotTechTerraform = cdnImage('Hire-Blockchain-developer/Terraform.webp');
const copilotTechDatadog = cdnImage('crypto-wallet-icons/Datadog.webp');
const copilotTechVSCode = cdnImage('ios/Visual-Studio-Code.webp');

export const copilotMilestonesData = [
    {value: '12+', text: 'AI Models &\nFrameworks Deployed'},
    {value: '2–4x', text: 'Faster Time-to-Market\nvia Pre-Trained AI Models'},
    {value: '50%', text: 'Reduction in Manual Effort\nvia AI Automation'},
    {value: '40%', text: 'Productivity Gains\nvia AI Copilots'},
    {value: '10+', text: 'Industries Served with\nAI Solutions'}
];

export const copilotGrowthData = {
    children: [
        {
            src: copilotGrowth1,
            redirect: 'https://www.meticulousresearch.com/product/ai-copilot-solutions-market-6559',
            heading: 'USD 121.6 Billion Market Forecast',
            content: [
                'The global AI copilot market is projected to reach <strong>USD 121.6 billion by 2032</strong>, expanding significantly from its current valuation as enterprises scale AI-driven productivity across business functions.'
            ]
        },
        {
            src: copilotGrowth2,
            redirect: 'https://www.thebusinessresearchcompany.com/report/artificial-intelligence-ai-copilot-market-report',
            heading: '30%+ CAGR Across Enterprise AI Adoption',
            content: [
                'The market is expected to grow at a <strong>compound annual growth rate exceeding 30%</strong>, reflecting accelerated enterprise adoption of copilots across engineering, operations, and customer-facing workflows.'
            ]
        },
        {
            src: copilotGrowth3,
            redirect: 'https://www.hcltech.com/blogs/roi-ai-measuring-productivity-gains-enterprise-copilot',
            heading: '40% of Enterprise Applications to Embed AI Copilots',
            content: [
                'By 2026, nearly <strong>40% of enterprise applications are expected to include AI copilots or task-specific AI agents</strong>, up from less than 5% in 2025—indicating rapid integration into core business systems.'
            ]
        },
        {
            src: copilotGrowth4,
            redirect: 'https://news.microsoft.com/ai-in-action/',
            heading: '90% of Fortune 500 Exploring or Using AI Copilots',
            content: [
                'AI copilots are already being adopted at scale, with <strong>nearly 90% of Fortune 500 companies leveraging Microsoft Copilot and related AI systems</strong> within enterprise environments.'
            ]
        }
    ]
};

const ksConsulting = cdnImage('ai-copliot-development-new/AI-Copilot-Consulting.webp');
const ksCustomApp = cdnImage('ai-copliot-development-new/Custom-App-Development-with-AI-Copilots.webp');
const ksSystemIntegration = cdnImage('ai-copliot-development-new/AI Copilot System Integration.webp');
const ksRag = cdnImage('ai-copliot-development-new/RAG Pipeline Development.webp');
const ksPromptEngineering = cdnImage('ai-copliot-development-new/Prompt-Engineering-Configuration.webp');
const ksMultiAgent = cdnImage('ai-copliot-development-new/Multi-Agent-Workflow-Orchestration.webp');
const ksDeployment = cdnImage('ai-copliot-development-new/Enterprise Copilot Platform Deployment.webp');
const ksTesting = cdnImage('ai-copliot-development-new/Testing-Support-ongoing-optimization.webp');
const ksTraining = cdnImage('ai-copliot-development-new/AI-Copilot-Training-Continuous-Learning.webp');
const ksGovernance = cdnImage('ai-copliot-development-new/AI-Governance-Security.webp');

export const copilotKeyServicesData = [
    {
        title: 'AI Copilot Strategy & Consulting',
        description:
            'We begin every engagement with a structured strategy development approach — mapping your workflows, identifying the highest-value automation and assistance opportunities, and defining a deployment roadmap aligned to your business outcomes. You leave with a clear, prioritised plan, not a generic AI strategy deck.',
        icon: ksConsulting,
        badges: ['Workflow Mapping', 'ROI Identification', 'Roadmap Planning', 'KPI Definition']
    },
    {
        title: 'Custom App Development with AI Copilots',
        description:
            'We build enterprise applications — internal tools, customer-facing products, and workflow platforms — with AI copilot capability integrated from the ground up. The copilot is not an add-on; it is a core functional layer of the product, trained on your domain context and connected to your data sources.',
        icon: ksCustomApp,
        badges: ['Copilot-First Design', 'Embedded AI Layer', 'Domain Training', 'Workflow Integration', 'Scalable Architecture']
    },
    {
        title: 'AI Copilot System Integration',
        description:
            'We connect AI copilots to the systems you already run: Salesforce, HubSpot, SAP, ServiceNow, Microsoft 365, custom ERPs, and proprietary platforms. Integration covers API connectivity, authentication, data pipelines, and workflow orchestration — ensuring the copilot operates within your governance and security requirements.',
        icon: ksSystemIntegration,
        badges: [
            'API Integration',
            'Data Pipelines',
            'System Connectivity',
            'Identity & Access',
            '<a target="_blank" href="/blog/ai-agents-for-workflow-automation">Workflow Automation</a>'
        ]
    },
    {
        title: 'RAG Pipeline Development',
        description:
            'Retrieval-Augmented Generation (RAG) allows copilots to answer questions grounded in your proprietary knowledge — documentation, contracts, product data, support history. We design, build, and optimize RAG pipelines that make your copilot genuinely knowledgeable about your business, not just generally capable.',
        icon: ksRag,
        badges: ['Knowledge Indexing', 'Vector Databases', 'Context Retrieval', 'Document Processing', 'Response Grounding']
    },
    {
        title: 'Prompt Engineering & Model Configuration',
        description:
            'The gap between a capable AI model and a high-performing enterprise copilot is <a href="/ai-prompt-engineering-company" target="_blank">prompt engineering</a> and fine-tuning. We configure system prompts, retrieval strategies, output formats, and behavioural guardrails that ensure your copilot responds accurately, consistently, and appropriately for your business context.',
        icon: ksPromptEngineering,
        badges: ['System Prompt Design', 'Output Structuring', 'Guardrail Setup', 'Model Tuning', 'Response Consistency']
    },
    {
        title: 'Multi-Agent Workflow Orchestration',
        description:
            'For complex enterprise workflows, a single copilot is rarely sufficient. We design and deploy multi-agent architectures where specialised <a href="/blog/what-are-ai-agents" target="_blank">AI agents</a> collaborate — one handling data retrieval, another drafting outputs, another validating against compliance rules — orchestrated into a seamless, reliable workflow.',
        icon: ksMultiAgent,
        badges: ['Agent collaboration', 'Task Orchestration', 'Workflow Automationm', 'Role-Based Agents', 'Decision Routing']
    },
    {
        title: 'Enterprise AI Copilot Deployment & Governance',
        description:
            'As organizations adopt enterprise copilots across ecosystems, deployment requires more than basic configuration. We manage platform rollout, access control, data governance, and enterprise integrations across environments such as Microsoft 365, Google Workspace, and custom stacks—ensuring secure, compliant, and scalable adoption from day one.',
        icon: ksDeployment,
        badges: ['Platform Deployment', 'Access Control', 'Data Governance', 'Environment Setup', 'Policy Enforcement']
    },
    {
        title: 'AI Copilot Testing, Support & Optimization',
        description:
            'We take full ownership through to production — including rigorous testing for accuracy, safety, and performance, CI/CD pipeline integration, and post-launch monitoring. Our ongoing optimization service ensures your copilot continues to improve as usage patterns evolve and new capabilities become available.',
        icon: ksTesting,
        badges: ['Performance Testing', 'Accuracy Validation', 'CI/CD Integration', 'Monitoring Setup', 'Continuous Optimization']
    },
    {
        title: 'AI Copilot Training & Continuous Learning',
        description:
            'We train and refine AI copilots using your enterprise data, workflows, and interaction patterns to improve accuracy, relevance, and domain alignment. This includes fine-tuning models (where applicable), feedback loop design, usage analytics, and continuous learning pipelines—ensuring your copilot becomes more effective, reliable, and context-aware over time.',
        icon: ksTraining,
        badges: ['Model Training', 'Feedback Loops', 'Usage Analytics', 'Continuous Learning', 'Domain Adaptation']
    },
    {
        title: 'AI Governance, Security & Compliance',
        description:
            'Enterprise copilots operate on sensitive data and critical workflows. We implement governance frameworks covering access control, audit trails, data privacy, model behaviour guardrails, and regulatory alignment—ensuring your copilot operates securely, transparently, and within compliance boundaries from day one.',
        icon: ksGovernance,
        badges: ['Data Privacy Controls', 'Audit Trails', 'Compliance Alignment', 'Risk Management', 'Security Guardrails']
    }
];

export const copilotCTA1Data = {
    heading: 'AI Copilots Are Easy to Access. Making Them Work at Scale Is Not.',
    subheading:
        'Most organisations can deploy a copilot. Very few succeed in embedding it into real workflows, connecting it to enterprise data, and driving consistent, measurable outcomes. The difference lies in how well the system is designed, integrated, and continuously improved.',
    bullets: [
        'Built around your workflows, not generic AI capabilities',
        'Integrated securely across systems, data sources, and user roles',
        'Continuously refined to improve accuracy, adoption, and business impact'
    ],
    buttonText: 'Get Custom Copilot Integration Plan',
    image: copilotCTAImg
};

export const copilotCTA2Data = {
    heading: 'Build an AI Copilot That Delivers Measurable Business Impact',
    subheading:
        'Deploying a copilot is straightforward. Making it reliable, secure, and aligned to your workflows is where most initiatives fall short. We help you design and implement copilots that integrate with your systems, operate on your data, and drive real operational efficiency from day one.',
    bullets: [
        'Seamless integration across your existing tools, platforms, and data sources',
        'Workflow-aware automation tailored to how your teams actually operate',
        'Secure architecture with governance, access control, and compliance built in',
        'Real-time insights generated directly from your business data',
        'Scalable deployment across cloud, hybrid, or on-premise environments',
        'Continuous optimisation based on usage patterns and performance'
    ],
    buttonText: 'Get In Touch With AI Experts',
    image: copilotCTA2Img
};

export const copilotCTA3Data = {
    heading: 'Ready to Implement an AI Copilot That Works for Your Business?',
    subheading:
        'Every copilot initiative involves its own mix of workflows, data dependencies, system integrations, and governance requirements. The fastest way to define scope, timelines, and feasibility is to align your use cases, data readiness, and system architecture upfront.',
    bullets: [],
    buttonText: 'Contact Expert AI Engineers Now!',
    image: copilotCTA3Img
};

const realResponse = cdnImage('ai-copliot-development-new/Real-Time-Responses.webp');
const contextRetention = cdnImage('ai-copliot-development-new/Context-Retention.webp');
const dataRetrieval = cdnImage('ai-copliot-development-new/Document-Retrieval.webp');
const dataProcessing = cdnImage('ai-copliot-development-new/Data-Processing.webp');
const cmdExecution = cdnImage('ai-copliot-development-new/Command-Execution.webp');
const dataAggregation = cdnImage('ai-copliot-development-new/Data-Aggregation.webp');
const responeFormatting = cdnImage('ai-copliot-development-new/Response-Formatting.webp');
const accessControl = cdnImage('ai-copliot-development-new/AI-Governance-Security.webp');
const multiTurn = cdnImage('ai-copliot-development-new/Multi-Turn-Interaction.webp');
const errorHandling = cdnImage('ai-copliot-development-new/Error-Handling.webp');
const sessionMemory = cdnImage('ai-copliot-development-new/API Security.webp');
const sourceAttribution = cdnImage('ai-copliot-development-new/Source-Attribution.webp');

export const copilotCoreFeaturesData = [
    {
        src: realResponse,
        redirect: '',
        heading: 'Real-Time Responses',
        body: 'Processes user inputs instantly and generates outputs with low latency using optimized model pipelines.'
    },
    {
        src: contextRetention,
        redirect: '',
        heading: 'Context Retention',
        body: 'Maintains conversational state across interactions, enabling continuity in multi-step workflows and reducing repetition.'
    },
    {
        src: dataRetrieval,
        redirect: '',
        heading: 'Document Retrieval',
        body: 'Fetches relevant information from indexed documents, databases, and knowledge systems to ground responses in internal data.'
    },
    {
        src: dataProcessing,
        redirect: '',
        heading: 'Data Processing',
        body: 'Handles both structured data (records, tables) and unstructured content (documents, emails) within a single interaction.'
    },
    {
        src: cmdExecution,
        redirect: '',
        heading: 'Command Execution',
        body: 'Converts natural language instructions into system-level actions such as queries, updates, or workflow triggers.'
    },
    {
        src: dataAggregation,
        redirect: '',
        heading: 'Data Aggregation',
        body: 'Pulls and combines information from multiple connected systems to deliver unified, context-rich responses.'
    },
    {
        src: responeFormatting,
        redirect: '',
        heading: 'Response Formatting',
        body: 'Generates outputs in structured formats such as summaries, tables, or system-ready inputs based on the use case.'
    },
    {
        src: accessControl,
        redirect: '',
        heading: 'Access Control',
        body: 'Filters responses based on user roles and permissions to ensure secure and relevant data visibility.'
    },
    {
        src: multiTurn,
        redirect: '',
        heading: 'Multi-Turn Interaction',
        body: 'Supports iterative conversations where each input builds on previous context without resetting the session.'
    },
    {
        src: errorHandling,
        redirect: '',
        heading: 'Error Handling',
        body: 'Identifies low-confidence outputs or missing data and applies fallback logic such as clarification prompts.'
    },
    {
        src: sessionMemory,
        redirect: '',
        heading: 'Session Memory',
        body: 'Persists user context across sessions to enable continuity beyond a single interaction and support long-running workflows.'
    },
    {
        src: sourceAttribution,
        redirect: '',
        heading: 'Source Attribution',
        body: 'Attaches references or citations to responses, allowing users to verify information against underlying documents or data sources.'
    }
];

export const copilotTechCategories = [
    {
        id: 'foundation-models',
        heading: 'Foundation Models & AI Engines',
        items: [
            {label: 'GPT-4', src: copilotTechOpenAI},
            {label: 'GPT-4o', src: copilotPlatformOpenAI},
            {label: 'Anthropic Claude', src: copilotTechClaude},
            {label: 'Gemini', src: copilotTechGemini},
            {label: 'Llama 3', src: copilotTechLlama},
            {label: 'Mistral', src: copilotTechMistral},
            {label: 'Cohere Command', src: copilotTechCohere}
        ],
        whyWeUseThem:
            'We leverage a mix of proprietary and open models to balance accuracy, cost, and performance. This allows us to select the right model per use case, support multi-model strategies, and avoid dependency on a single provider.'
    },
    {
        id: 'copilot-platforms',
        heading: 'Copilot Platforms & Deployment Environments',
        items: [
            {label: 'Microsoft Copilot', src: copilotTechMsCopilot},
            {label: 'Azure OpenAI Service', src: copilotTechAzureOpenAI},
            {label: 'OpenAI API', src: copilotPlatformOpenAI},
            {label: 'Google Vertex AI', src: copilotTechVertexAI},
            {label: 'AWS Bedrock', src: copilotTechAWS}
        ],
        whyWeUseThem:
            'These platforms provide managed environments for deploying copilots with built-in scalability, security, and compliance controls, reducing infrastructure overhead while accelerating time to production.'
    },
    {
        id: 'orchestration',
        heading: 'Copilot Orchestration Frameworks',
        items: [
            {label: 'LangChain', src: copilotTechLangChain},
            {label: 'LlamaIndex', src: copilotTechLlamaIndex},
            {label: 'Semantic Kernel', src: copilotTechSemanticKernel},
            {label: 'Haystack', src: copilotTechHaystack},
            {label: 'DSPy', src: copilotTechDSPy}
        ],
        whyWeUseThem:
            'Orchestration frameworks help structure how copilots process inputs, retrieve data, and generate outputs, enabling complex workflows, multi-step reasoning, and integration across systems.'
    },
    {
        id: 'rag-vector',
        heading: 'RAG Pipelines & Vector Databases',
        items: [
            {label: 'Pinecone', src: copilotTechPinecone},
            {label: 'Weaviate', src: copilotTechWeaviate},
            {label: 'FAISS', src: copilotTechFAISS},
            {label: 'Chroma', src: copilotTechChroma},
            {label: 'Milvus', src: copilotTechWeaviate},
            {label: 'Elasticsearch', src: copilotTechElasticsearch}
        ],
        whyWeUseThem:
            'These tools enable retrieval-based systems that ground responses in real data. They improve accuracy, reduce hallucinations, and allow copilots to work with internal knowledge sources.'
    },
    {
        id: 'data-integration',
        heading: 'Enterprise Data Integration & Processing',
        items: [
            {label: 'Apache Kafka', src: copilotTechKafka},
            {label: 'Apache Spark', src: spark},
            {label: 'Airflow', src: copilotTechAirflow},
            {label: 'dbt', src: copilotTechDatabricks},
            {label: 'Snowflake', src: copilotTechSnowflake},
            {label: 'Databricks', src: copilotTechDatabricks}
        ],
        whyWeUseThem:
            'We use these technologies to build reliable data pipelines that ingest, process, and prepare data for AI Copilot usage, ensuring consistency, scalability, and real-time availability.'
    },
    {
        id: 'backend',
        heading: 'Backend Systems & API Layers',
        items: [
            {label: 'Node.js', src: copilotTechNodeJS},
            {label: 'Python (FastAPI, Flask)', src: copilotTechPython},
            {label: '.NET', src: copilotTechDotNet},
            {label: 'Java Spring Boot', src: copilotTechSpringBoot},
            {label: 'REST APIs', src: restfulAPIs},
            {label: 'GraphQL', src: graphql}
        ],
        whyWeUseThem:
            'Backend systems handle business logic, API orchestration, and system integrations, enabling copilots to interact with applications, execute actions, and process requests efficiently.'
    },
    {
        id: 'interfaces',
        heading: 'Copilot Interfaces & Interaction Layers',
        items: [
            {label: 'React.js', src: copilotTechReact},
            {label: 'Next.js', src: copilotTechNextJs},
            {label: 'TypeScript', src: copilotTechTypeScript},
            {label: 'WebSockets', src: WebRTC},
            {label: 'Chat UI frameworks', src: copilotTechReact}
        ],
        whyWeUseThem:
            'These tools enable intuitive user interfaces and real-time interactions, allowing users to engage with copilots seamlessly within web apps, dashboards, and internal tools.'
    },
    {
        id: 'cloud',
        heading: 'Cloud Infrastructure & Deployment',
        items: [
            {label: 'Microsoft Azure', src: copilotTechAzure},
            {label: 'AWS', src: copilotTechAWS},
            {label: 'Google Cloud Platform', src: copilotTechGCP},
            {label: 'Docker', src: copilotTechDocker},
            {label: 'Kubernetes', src: copilotTechKubernetes},
            {label: 'Terraform', src: copilotTechTerraform}
        ],
        whyWeUseThem:
            'Cloud and containerization technologies ensure scalable, resilient deployments with flexible infrastructure management, supporting high availability and performance.'
    },
    {
        id: 'governance',
        heading: 'Copilot Governance, Security & Monitoring',
        items: [
            {label: 'Azure AD (Entra ID)', src: copilotTechAzure},
            {label: 'OAuth 2.0', src: auth},
            {label: 'RBAC', src: iam},
            {label: 'Open Policy Agent', src: iam},
            {label: 'Langfuse', src: copilotTechLangChain},
            {label: 'PromptLayer', src: copilotTechLangChain},
            {label: 'Datadog', src: copilotTechDatadog}
        ],
        whyWeUseThem:
            'These tools enforce access control, monitor system behavior, and track performance, ensuring secure operation, auditability, and continuous optimization of copilot systems.'
    },
    {
        id: 'dev-tools',
        heading: 'Developer Productivity & Engineering Tools',
        items: [
            {label: 'GitHub Copilot', src: copilotTechGitHub},
            {label: 'VS Code', src: copilotTechVSCode},
            {label: 'Jupyter Notebooks', src: copilotTechPython},
            {label: 'Postman', src: postman},
            {label: 'CI/CD pipelines', src: copilotTechDocker}
        ],
        whyWeUseThem:
            'These tools streamline development, testing, and deployment workflows, improving engineering efficiency and ensuring faster, more reliable delivery of copilot systems.'
    }
];

export const copilotExpertsData = [
    {
        name: 'Gurpreet Singh',
        designation: 'AI Consultant & Advisor, Debut Infotech',
        image: copilotExpertGurpreet,
        linkedin: 'https://www.linkedin.com/in/gurpreet-singh-630b5a12/',
        quote: "We've stepped into enough AI initiatives mid-stream to understand exactly where things start to fail. Use cases that were never prioritized against business impact. Data pipelines that weren't production-ready. AI models that performed in isolation but failed in real-world operations. The approach we follow today is shaped by solving these gaps — helping enterprises move from experimentation to measurable performance, without the inefficiencies that stall most AI programs."
    },
    {
        name: 'Harry Dhillon',
        designation: 'Director – Digital Transformation & Customer Success, Debut Infotech',
        image: copilotExpertHarry,
        linkedin: 'https://www.linkedin.com/in/dhillonharry/',
        quote: "We've worked with enough enterprises navigating AI adoption to see a consistent pattern. Strong ambition, but fragmented execution. Pilots that never scale. Automation efforts that improve tasks but fail to transform outcomes. The approach we drive today is built on bridging that gap — taking AI from isolated experiments to enterprise-wide systems that deliver measurable impact, operational clarity, and sustained growth."
    }
];

export const copilotCostData = {
    heading: 'AI Copilot Development Cost & Timeline',
    subheading:
        'Organizations evaluating AI copilot development and integration—whether for internal productivity, customer support, or decision automation—must account for several key investment drivers: workflow complexity, data readiness, system integrations, model selection, and governance requirements.',
    rangeText:
        'For teams looking to validate their AI copilot initiative before full-scale rollout, an MVP focused on core workflows, limited data integration, and a functional interface typically ranges from:',
    costItems: [
        {
            label: 'MVP Development',
            value: '$10,000 – $60,000+'
        },
        {
            label: 'Integration Services',
            value: '$5,000 – $25,000+'
        }
    ],
    rangeSubtext:
        'MVP scope, timeline, and cost vary based on the number of workflows covered, depth of system integration, and level of accuracy required. Teams with clearly defined use cases and structured data environments typically move from concept to initial deployment within <strong>4 to 10 weeks</strong>.',
    accordions: [
        {
            title: 'What Drives AI Copilot Development Cost?',
            type: 'bullets',
            introText: 'The total cost of an AI copilot solution is influenced by:',
            items: [
                {title: 'Number and complexity of workflows being automated'},
                {title: 'Depth of integration with CRM, ERP, support tools, and internal systems'},
                {title: 'Data availability, quality, and preparation effort'},
                {title: 'RAG implementation and knowledge base complexity'},
                {title: 'Model selection (API-based vs fine-tuned vs multi-model orchestration)'},
                {title: 'Security, access control, and compliance requirements'},
                {title: 'Testing, monitoring, and ongoing optimisation scope'}
            ],
            footer: 'Projects with well-defined requirements, clean data, and a focused initial use case consistently deliver faster and at the lower end of the cost range.'
        },
        {
            title: 'Estimated Cost by AI Copilot Type',
            type: 'projectTable',
            items: [
                {
                    type: 'Internal Productivity Copilot',
                    cost: '$10,000 – $40,000',
                    integrationCost: '$5,000 – $20,000',
                    timeline: '3–6 weeks'
                },
                {type: 'Customer Support Copilot', cost: '$25,000 – $80,000', integrationCost: '$10,000 – $40,000', timeline: '4–8 weeks'},
                {type: 'Sales & CRM Copilot', cost: '$40,000 – $120,000', integrationCost: '$20,000 – $60,000', timeline: '6–10 weeks'},
                {
                    type: 'Operations & Workflow Automation Copilot',
                    cost: '$80,000 – $200,000',
                    integrationCost: '$30,000 – $100,000',
                    timeline: '8–16 weeks'
                },
                {
                    type: 'Multi-System / Advanced Copilot Platform',
                    cost: '$150,000 – $500,000+',
                    integrationCost: '$50,000 – $200,000+',
                    timeline: '4–8 months'
                }
            ]
        },
        {
            title: 'How Workflow Complexity Impacts Cost & Timeline?',
            type: 'timelineBullets',
            introText: 'Timeline and system scope evolve together based on how deeply the copilot is embedded into your operations.',
            items: [
                {label: 'Single-use copilot (FAQ, basic automation)', time: '3–5 weeks'},
                {label: 'Multi-workflow copilot with CRM/ERP integration', time: '6–10 weeks'},
                {label: 'Cross-functional copilot with RAG and decision support', time: '3–5 months'},
                {label: 'Full-scale copilot ecosystem with multi-agent orchestration', time: '6–8+ months'}
            ],
            footer: 'Compressed timelines without proper testing, validation, and guardrails often lead to unreliable outputs, low adoption, and rework—offsetting any initial time savings.'
        },
        {
            title: 'Model & Integration Choices and Cost Implications',
            type: 'platformBullets',
            introText: 'Your choice of models and integration approach directly impacts both cost and long-term scalability:',
            items: [
                {platform: 'API-based models', impact: 'Faster deployment and lower upfront cost; suitable for most use cases'},
                {platform: 'Fine-tuned models', impact: 'Higher setup effort; improves accuracy for domain-specific workflows'},
                {platform: 'Multi-model orchestration', impact: 'Balances cost, performance, and capability across use cases'},
                {
                    platform: 'Deep system integrations',
                    impact: 'Increase development effort but significantly improve business impact'
                }
            ],
            footer: 'Selecting an incomplete integration strategy often results in copilots that cannot access real data, limiting their usefulness despite initial development investment.'
        }
    ]
};

export const copilotFAQData = [
    {
        category: 'AI Copilot Development & Integration',
        questions: [
            {
                q: 'What is the difference between AI Copilot development and AI Copilot integration?',
                a: 'Most organisations do not need to build a new AI model — they need to deploy existing models effectively within their workflows. AI copilot development refers to building the application, interface, and logic layer that wraps around foundation models like GPT-4 or Claude. AI copilot integration refers to connecting that capability to your existing enterprise systems — your CRM, ERP, support desk, or custom applications. Debut Infotech specialises in both, with a focus on the integration layer that determines real-world usefulness.'
            },
            {
                q: 'Which AI models do you work with?',
                a: 'We work across the leading foundation models: OpenAI GPT-4 and GPT-4o, Anthropic Claude, Google Gemini, Meta Llama 3, Mistral AI, and Cohere Command. For Microsoft-aligned organisations, we also deploy and configure Microsoft 365 Copilot and Azure OpenAI Service. Model selection is based on your specific use case, compliance requirements, and existing technology agreements — not a fixed preference.'
            },
            {
                q: 'How long does an AI copilot integration project typically take?',
                a: 'A focused integration engagement — for example, connecting a RAG-powered support copilot to an existing helpdesk system — can be delivered in six to ten weeks. More complex deployments involving custom application development, multi-system integration, or regulated environments typically range from three to six months. We provide a detailed timeline as part of the scoping phase.'
            },
            {
                q: 'How do you handle data security and compliance?',
                a: 'Security and compliance are architectural requirements, not afterthoughts. We design data flows, access controls, and audit mechanisms into the copilot solution from the beginning. For regulated industries, we work within frameworks including GDPR, HIPAA, SOC 2, and relevant regional data protection standards. All sensitive data remains within your controlled environment — we do not route enterprise data through third-party infrastructure without explicit approval and contractual safeguards.'
            },
            {
                q: 'Do we need to replace our existing systems to deploy an AI copilot?',
                a: 'No. Our integration approach is specifically designed to work within your existing technology stack. We connect AI copilots to your current systems via APIs and custom connectors — your CRM, ERP, communication platforms, and proprietary tools remain unchanged. The copilot becomes an intelligent layer operating on top of your existing infrastructure.'
            },
            {
                q: 'What ongoing support do you provide after deployment?',
                a: 'We offer a structured post-deployment optimisation service that includes performance monitoring against agreed success metrics, model and prompt refinement as usage patterns evolve, and ongoing development for new capabilities or integrations. Support arrangements are scoped based on your operational requirements — from lightweight monitoring through to a fully retained development partnership.'
            }
        ]
    }
];

const pna = cdnImage('ai-copliot-development-new/Private Network Architecture.webp');
const ns = cdnImage('ai-copliot-development-new/Network-Segmentation.webp');
const de = cdnImage('ai-copliot-development-new/Data-Encryption.webp');
const rbac = cdnImage('ai-copliot-development-new/Role-Based Access Control.webp');
const mfa = cdnImage('ai-copliot-development-new/Multi-Factor Authentication.webp');
const iam2 = cdnImage('ai-copliot-development-new/Identity Access Management.webp');
const cap = cdnImage('ai-copliot-development-new/Conditional Access Policies.webp');
const agp = cdnImage('ai-copliot-development-new/API Security.webp');
const alat = cdnImage('ai-copliot-development-new/Audit Logging Activity.webp');
const rtmtd = cdnImage('ai-copliot-development-new/Real-Time Monitoring.webp');
const cpe = cdnImage('ai-copliot-development-new/Testing-Support-ongoing-optimization.webp');
const aog = cdnImage('ai-copliot-development-new/AI-Governance-Security.webp');

export const copilotSecurityFrameworks = [
    {title: 'Private Network Architecture & Secure Connectivity', icon: pna},
    {title: 'Network Segmentation & Access Isolation', icon: ns},
    {title: 'Data Encryption (At Rest & In Transit)', icon: de},
    {title: 'Role-Based Access Control (RBAC)', icon: rbac},
    {title: 'Multi-Factor Authentication (MFA)', icon: mfa},
    {title: 'Identity & Access Management (IAM)', icon: iam2},
    {title: 'Conditional Access Policies', icon: cap},
    {title: 'API Security & Gateway Protection', icon: agp},
    {title: 'Audit Logging & Activity Tracking', icon: alat},
    {title: 'Real-Time Monitoring & Threat Detection', icon: rtmtd},
    {title: 'Compliance & Policy Enforcement', icon: cpe},
    {title: 'AI Output Guardrails & Safety Controls', icon: aog}
];

export const copilotIndustriesData = [
    {
        title: 'Healthcare',
        redirect: '/healthcare-app-development-company',
        description: 'Improve clinical efficiency, reduce administrative burden, and enable faster, data-driven patient care.',
        points: [
            'Clinical documentation assistant (SOAP notes, discharge summaries)',
            'Patient inquiry and triage copilot',
            'Prior authorisation and insurance query automation',
            'HIPAA-compliant knowledge retrieval for clinical staff'
        ],
        image: copilotIndHealthcare,
        imageAlt: 'AI Copilot for Healthcare'
    },
    {
        title: 'FinTech & Banking',
        redirect: '/fintech-software-development',
        description: 'Enhance decision-making, ensure regulatory compliance, and streamline financial operations at scale.',
        points: [
            'Regulatory compliance research and summarisation copilot',
            'Loan underwriting decision-support assistant',
            'Fraud investigation and anomaly reporting copilot',
            'Client-facing financial advisory chatbot with portfolio context'
        ],
        image: copilotIndFintech,
        imageAlt: 'AI Copilot for FinTech & Banking'
    },
    {
        title: 'Retail & E-Commerce',
        redirect: '/blog/ai-agents-in-retail-and-e-commerce',
        description: 'Drive conversion, personalise customer journeys, and optimise merchandising and support workflows.',
        points: [
            'RAG-powered customer support and product recommendation copilot',
            'Merchandising and inventory insight assistant',
            'Personalised shopping assistant embedded in product pages',
            'Post-purchase query and returns management copilot'
        ],
        image: copilotIndRetail,
        imageAlt: 'AI Copilot for Retail & E-Commerce'
    },
    {
        title: 'Manufacturing',
        redirect: '/blog/role-of-ai-in-manufacturing-industry',
        description: 'Increase operational efficiency, reduce downtime, and improve production quality across facilities.',
        points: [
            'Predictive maintenance alert and diagnostic copilot',
            'Quality control and defect classification assistant',
            'Production scheduling and optimisation copilot',
            'Technical documentation and SOP retrieval assistant'
        ],
        image: copilotIndManufacturing,
        imageAlt: 'AI Copilot for Manufacturing'
    },
    {
        title: 'Logistics & Supply Chain',
        redirect: '/blog/understanding-the-role-of-ai-in-logistics-supply-chain',
        description: 'Enable real-time visibility, optimise logistics decisions, and improve supply chain resilience.',
        points: [
            'Real-time shipment tracking and exception management copilot',
            'Demand forecasting and inventory reorder assistant',
            'Carrier selection and route optimisation copilot',
            'Customs documentation and compliance query assistant'
        ],
        image: copilotIndLogistics,
        imageAlt: 'AI Copilot for Logistics & Supply Chain'
    },
    {
        title: 'Real Estate',
        redirect: '/real-estate-software-development',
        description: 'Accelerate deal cycles, improve client engagement, and enhance data-driven property insights.',
        points: [
            'Property search and recommendation copilot for brokers and portals',
            'Lease and contract analysis assistant',
            'Lead qualification and nurturing copilot',
            'Market intelligence and valuation research assistant'
        ],
        image: copilotIndRealEstate,
        imageAlt: 'AI Copilot for Real Estate'
    },
    {
        title: 'Education',
        redirect: '/education-app-development-company',
        description: 'Support personalised learning, automate academic workflows, and improve student engagement.',
        points: [
            'Personalised tutoring and learning pathway copilot',
            'Automated assessment generation and grading assistant',
            'Student support and query resolution copilot',
            'Curriculum planning and content development assistant'
        ],
        image: copilotIndEducation,
        imageAlt: 'AI Copilot for Education'
    },
    {
        title: 'Legal',
        redirect: '/use-cases/generative-ai-for-legal-operations',
        description: 'Reduce manual effort in legal workflows while improving accuracy and research efficiency.',
        points: [
            'Contract review and clause extraction copilot',
            'Legal research and precedent summarisation assistant',
            'Client intake and matter classification copilot',
            'Compliance monitoring and regulatory update assistant'
        ],
        image: copilotIndLegal,
        imageAlt: 'AI Copilot for Legal'
    },
    {
        title: 'Insurance',
        redirect: '/blog/ai-driven-insurance-enterprises-all-set-to-break-records',
        description: 'Streamline policy management, accelerate claims processing, and improve risk assessment accuracy.',
        points: [
            'Claims processing and adjudication copilot',
            'Underwriting risk analysis assistant',
            'Fraud detection and investigation copilot',
            'Policy servicing and customer query assistant'
        ],
        image: copilotIndInsurance,
        imageAlt: 'AI Copilot for Insurance'
    },
    {
        title: 'Travel & Hospitality',
        redirect: '/use-cases/ai-in-hospitality-industry',
        description: 'Enhance guest experience, automate service operations, and optimise booking workflows.',
        points: [
            'AI concierge and booking assistant',
            'Dynamic pricing and revenue optimisation copilot',
            'Customer support and itinerary management copilot',
            'Feedback analysis and service improvement assistant'
        ],
        image: copilotIndTravel,
        imageAlt: 'AI Copilot for Travel & Hospitality'
    },
    {
        title: 'Media & Entertainment',
        redirect: '/media-entertainment-software-development',
        description: 'Accelerate content production, improve audience engagement, and optimise distribution strategies.',
        points: [
            'Content ideation and script generation copilot',
            'Audience sentiment and trend analysis assistant',
            'Media asset tagging and retrieval copilot',
            'Personalised content recommendation assistant'
        ],
        image: copilotIndMedia,
        imageAlt: 'AI Copilot for Media & Entertainment'
    },
    {
        title: 'Telecom',
        redirect: '/blog/role-of-blockchain-in-telecom-industry',
        description: 'Optimise network operations, improve customer support, and manage large-scale service environments.',
        points: [
            'Network diagnostics and outage resolution copilot',
            'Customer support and ticket resolution assistant',
            'Plan recommendation and upsell Copilot',
            'Knowledge base retrieval for support agents'
        ],
        image: copilotIndTelecom,
        imageAlt: 'AI Copilot for Telecom'
    }
];

const microsoft365 = cdnImage('ai-copliot-development-new/Microsoft-365 Copilot-Deployment.webp');
const azureOpen = cdnImage('ai-copliot-development-new/Azure OpenAI Copilot Architecture.webp');
const claudeCopilot = cdnImage('ai-copliot-development-new/Claude-Based Copilot Systems.webp');
const gptCopilot = cdnImage('ai-copliot-development-new/GPT-Based Copilot Development.webp');
const githubBased = cdnImage('ai-copliot-development-new/GitHub Copilot-and-developer-workflow.webp');

export const aiCopilotPlatformsData: PlatformPreviewItem[] = [
    {
        id: 1,
        imageSrc: microsoft365,
        alt: 'Microsoft 365 Copilot Deployment & Configuration',
        imageLeft: true,
        title: 'Microsoft 365 Copilot Deployment & Configuration',
        subtitle: '',
        description:
            'Roll out Microsoft 365 Copilot with structured configuration across environments, ensuring controlled access and business-aligned usage.',
        bullets: [
            'Identity integration with Microsoft Entra ID and role-based access control',
            'Conditional access policies aligned to security posture',
            'SharePoint, Teams, and Outlook integration for contextual assistance',
            'Tenant-level configuration for controlled copilot behaviour'
        ],
        ctaLabel: '',
        ctaHref: ''
    },
    {
        id: 2,
        imageSrc: azureOpen,
        alt: 'Azure OpenAI Copilot Architecture & Deployment',
        imageLeft: false,
        title: 'Azure OpenAI Copilot Architecture & Deployment',
        subtitle: '',
        description: 'Design production-ready copilots using Azure OpenAI with secure, scalable cloud architecture.',
        bullets: [
            'Deployment within private environments and secure VNets',
            'Secure API layers for controlled data interaction',
            'Scalable architecture for high-volume workloads',
            'Integration with enterprise applications and workflows'
        ],

        ctaLabel: '',
        ctaHref: ''
    },
    {
        id: 3,
        imageSrc: gptCopilot,
        alt: 'GPT-Based Copilot Development & Integration',
        imageLeft: true,
        title: 'GPT-Based Copilot Development & Integration',
        subtitle: '',
        description: 'Build advanced copilots using GPT models tailored to specific business workflows and use cases.',
        bullets: [
            'Custom copilot logic for automation and decision support',
            'Workflow integration across business systems',
            'Prompt design for structured and reliable outputs',
            'Fine-tuned responses aligned to business context'
        ],
        ctaLabel: '',
        ctaHref: ''
    },
    {
        id: 4,
        imageSrc: claudeCopilot,
        alt: 'Claude-Based Copilot Systems for Reasoning Workflows',
        imageLeft: false,
        title: 'Claude-Based Copilot Systems for Reasoning Workflows',
        subtitle: '',
        description: 'Leverage Anthropic Claude for use cases requiring deeper reasoning, long-context handling, and structured outputs.',
        bullets: [
            'Long-document analysis and summarisation',
            'High-accuracy reasoning for complex workflows',
            'Safer outputs with controlled response behaviour',
            'Context-heavy use case optimisation'
        ],
        ctaLabel: '',
        ctaHref: ''
    },
    {
        id: 5,
        imageSrc: githubBased,
        alt: 'GitHub Copilot & Developer Workflow Integration',
        imageLeft: true,
        title: 'GitHub Copilot & Developer Workflow Integration',
        subtitle: '',
        description: 'Integrate GitHub Copilot into engineering workflows to accelerate development and improve code quality.',
        bullets: [
            'Code generation, debugging, and documentation assistance',
            'Integration into CI/CD and development pipelines',
            'Context-aware coding using repositories',
            'Developer productivity and output optimisation'
        ],
        ctaLabel: '',
        ctaHref: ''
    }
];

const award2024 = cdnImage('ai-copliot-development-new/techbehmoths-award-ai-2024 1.webp');
const award2025 = cdnImage('ai-copliot-development-new/techbehmoths-award-ai-2024 2.webp');
const selectedFirmsAi = cdnImage('ai-copliot-development-new/Selectedfirms-top-ai-development-company.webp');
const webAward = cdnImage('about-us-new/Web-development-award.webp');
const manifestBlockchainAi = cdnImage('Blockchain-images/top_the_manifest_blockchain_marketing_2024_award.webp');
const manifestNFTAi = cdnImage('Blockchain-images/top_the_manifest_nft_design_2024_award.webp');
const goodfirmAi = cdnImage('Blockchain-images/blockchain-technology-companies-goodfirms.webp');
const techbehemothsBlockchain2024Ai = cdnImage('Blockchain-images/techbehmoths-award-blockchain-2024.webp');
const selectedFirmsBlockchainAi = cdnImage('Blockchain-images/Selectedfirm-top-blockchain-developement-company.webp');

export const aiAwardsList = [
    {
        title: 'Top AI Company 2024',
        image: award2024
    },
    {
        title: 'Top AI Company 2025',
        image: award2025
    },
    {
        title: 'Top AI Development Company',
        image: selectedFirmsAi
    },
    {
        title: 'Top Web Development Companies 2026',
        image: webAward
    },
    {
        title: 'Top Blockchain Development Companies',
        image: goodfirmAi,
        link: 'https://www.goodfirms.co/companies/blockchain-development-services'
    },
    {
        title: 'Top Blockchain Company 2024',
        image: techbehemothsBlockchain2024Ai,
        link: 'https://techbehemoths.com/company/debut-infotech'
    },
    {
        title: 'Top Blockchain Development Company',
        image: selectedFirmsBlockchainAi,
        link: 'https://selectedfirms.co/companies/blockchain-development'
    },
    {
        title: 'Top Blockchain Marketing 2024',
        image: manifestBlockchainAi,
        link: 'https://themanifest.com/company/debut-infotech'
    },
    {
        title: 'Top NFT Design 2024',
        image: manifestNFTAi,
        link: 'https://themanifest.com/company/debut-infotech'
    }
];
